import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class MensalidadeApi extends Api {
  async consultarMensalidades (mes, ano) {
    let mensalidades = [];
    const brancoAcoes = '';
    try {
      const mensalidadesUrl = resolve('mensalidadesUrl') + mes + '/' + ano;
      const { data } = await this.fetch(mensalidadesUrl);
      data.map(res => {
        const { numSeqMensalidade, numAnoInicio, numMesInicio, numAnoFim, numMesFim, dtaInicio, dtaFim, codUsuarioCadastro, dtaCadastro, qtdeRegistrosComValorZerado, valorSeguro } = res;
        mensalidades.push(Object.values({ numSeqMensalidade, numAnoInicio, numMesInicio, numAnoFim, numMesFim, dtaInicio, dtaFim, codUsuarioCadastro, dtaCadastro, qtdeRegistrosComValorZerado, valorSeguro, brancoAcoes }));
      });
      return mensalidades || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarValoresMensalidade (numSeqMensalidade, apenasValoresZerados) {
    let valoresMensalidade = [];
    try {
      const valoresMensalidadeUrl = resolve('valoresMensalidadeUrl') + numSeqMensalidade + '/' + apenasValoresZerados;
      const { data } = await this.fetch(valoresMensalidadeUrl);
      data.map(res => {
        const { seqMensalidade, seqValor, codTipoMensalidade, desTipoMensalidade, seqRemuneracao, desRemuneracao, seqIdade, desIdade, codUsuarioCadastro, valMensalidade, dtaCadastro } = res;
        valoresMensalidade.push(Object.values({ seqMensalidade, seqValor, codTipoMensalidade, desTipoMensalidade, seqRemuneracao, desRemuneracao, seqIdade, desIdade, codUsuarioCadastro, valMensalidade, dtaCadastro }));
      });
      return valoresMensalidade || [];
    } catch (error) {
      console.error(error);
    }
  }

  async excluirMensalidade (seqMensalidade) {
    try {
      const urlExcluirMensalidade = resolve('urlExcluirMensalidade') + '/' + seqMensalidade;
      const response = await this.fetch(urlExcluirMensalidade, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarUltimaMensalidade () {
    try {
      const urlConsultarUltimaMensalidade = resolve('urlConsultarUltimaMensalidade');
      const response = await this.fetch(urlConsultarUltimaMensalidade);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirMensalidade (reajuste) {
    try {
      const urlIncluirMensalidade = resolve('urlIncluirMensalidade');
      const response = await this.fetch(urlIncluirMensalidade, 'put', reajuste);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async salvarValorMensalidade (valorMensalidade) {
    try {
      const urlSalvarValorMensalidade = resolve('urlSalvarValorMensalidade');
      const response = await this.fetch(urlSalvarValorMensalidade, 'put', valorMensalidade);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarSeguro (seqMensalidade) {
    try {
      const urlConsultarSeguro = resolve('urlConsultarSeguro') + seqMensalidade;
      const response = await this.fetch(urlConsultarSeguro);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarVigenciasSeguro () {
    let vigencias = [];
    try {
      const urlConsultarVigenciasSeguro = resolve('urlConsultarVigenciasSeguro');
      const { data } = await this.fetch(urlConsultarVigenciasSeguro);
      data.map(res => {
        const { codVigencia, valPorte, dtaInicio, dtaFim, codUsuarioCadastro, nomeUsuarioCadastro, dtaCancelamento, txtMotivoCancelamento } = res;
        vigencias.push(Object.values({ codVigencia, valPorte, dtaInicio, dtaFim, codUsuarioCadastro, nomeUsuarioCadastro, dtaCancelamento, txtMotivoCancelamento }));
      });
      return vigencias || [];
    } catch (error) {
      console.error(error);
    }
  }  
}
export default MensalidadeApi;
